var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.resolvedSelector)?_c('mounting-portal',{attrs:{"mount-to":_vm.resolvedSelector,"append":""},scopedSlots:_vm._u([(_vm.glSlots().default)?{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}:null],null,true)}):_c('div',{attrs:{"hidden":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }